export default {"src":"/_next/static/media/profile-powers.2ab59abf.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};